import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import BaseAdministrators from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAdministrators';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {administratorsIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.administrators;
const pageId = pageSchema.pageId;

function GatewayAdministrators({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.administrators.fieldId], planPage[pageSchema.administrators.fieldId]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.ADMINISTRATORS')}
            icon={administratorsIcon}
        >
            <BaseAdministrators
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.Administrators')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.ADMINISTRATORS')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayAdministrators;